// 쿠패스(중국 창고) 화면의 상태 표시 라벨 — 저장 키(한국어)는 그대로 두고 화면에 보이는 글자만 중국어로 바꾼다.
// 기존 화면 표기를 모았다: 已付款·运输中·已签收·入库待发(logisPaidOrderListV0), 待出库·待确认出库·待上架库存(logisInboundListV0),
// 入库错误·入库完成·退货确认·退货完成·废弃确认·废弃完成(logisImportErrorListV0).
// 순서는 server.js WEBHOOK_STATUS_ORDER(= logisaddimportV0 STATUS_ORDER) 와 같다.
export const PROCESS_STATUS_TEXT = {
  구매전: '待采购', 협상중: '协商中', 구매확인: '采购确认', 구매보류: '采购保留', 구매취소: '采购取消',
  입금요청: '已发账单客户未转账', 입금완료: '已入账', 구매완료: '已付款',
  배송중: '运输中', 배송완료: '已签收', 입고작업: '入库作业中',
  출고확인대기: '待确认出库', 재고대기: '待上架库存', 출고요청: '出库申请', 출고대기: '待出库', 출고완료: '已出库',
  중국재고: '中国库存', 입고오류: '入库错误', 입고완료: '入库完成',
  반품확인: '退货确认', 폐기확인: '废弃确认', 입고대기: '入库待发', 반품완료: '退货完成', 폐기완료: '废弃完成',
  미도착종결: '缺货结单',
  해외입고중: '海外入库中', 국내창고입고중: '韩国仓库入库中', 국내창고입고완료: '韩国仓库入库完成',
  국내입고중: '韩国入库中', 쿠팡센터입고완료: '酷澎中心入库完成'
};

// 입고오류상세.오류상태(입고처리 화면 처리방법 결과) 표기
export const ERROR_STATUS_TEXT = {
  접수: '已登记', 입고완료처리: '入库完成处理', 반품진행: '退货', 폐기진행: '废弃',
  입고대기: '入库待发', 판매자재발송: '商家补发', 교환진행: '换货', 미도착종결: '缺货结单'
};

// 모르는 상태는 원래 값 그대로(빈 칸으로 숨기지 않는다)
export function processStatusText(v) {
  return PROCESS_STATUS_TEXT[v] || v || '';
}

export function errorStatusText(v) {
  return ERROR_STATUS_TEXT[v] || v || '';
}

// 待客户确认 处理状态(요청내역.confirmStatus) — 저장키는 한국어, 화면은 중국어(한국어). 빈 값 = 확인중(2026-10-04 YZY)
// 서버 CONFIRM_STATUS_KEYS(server.js /api/reqpurchase/import/confirmstate) 와 같은 키·순서
export const CONFIRM_STATUS_OPTIONS = [
  { value: '대기회신', text: '待回复(회신대기)' },
  { value: '확인중', text: '确认中(확인중)' },
  { value: '처리완료', text: '处理完成(처리완료)' }
];
export function confirmStatusText(v) {
  const o = CONFIRM_STATUS_OPTIONS.find(x => x.value === (v || '확인중'));
  return o ? o.text : v;
}
// 이름 + 代号 — 「张三(A1)」. 代号가 없으면 이름만
export function staffLabel(name, code) {
  return name ? (code ? name + '(' + code + ')' : name) : '';
}

// 通关方式(통관방식) 표시 — 저장값(요청내역.customsType / 파렛트 라벨 customsType)은 그대로, 쿠패스 화면 라벨만(2026-10 YZY).
// 托盘标签生成 선택지·货主库存出库·入库列表 엑셀이 같이 쓴다. 모르는 값·빈 값은 빈칸
export const CUSTOMS_TYPE_TEXT = {
  integrated: '综合清关(통합통관)',
  kupass: 'COUPASS单独清关',
  client: '货主单独清关'
};
export function customsTypeText(v) {
  return CUSTOMS_TYPE_TEXT[v] || '';
}

// 出库形式(출고형태) 표시 — 창고가 테이프 색으로 구분한다(2026-10 YZY). 저장값은 그대로 두고 화면 라벨·색만 바꾼다.
// 저장값은 두 갈래다: 박스·파렛트 라벨(Labels.shipmentType = milkrun_box …)과 구매요청 물류방법(밀크런택배·밀크런트럭·일반택배·일반트럭).
// 둘 다 여기로 모은다. 모르는 값은 원래 글자 그대로, 색 없이.
// 표기는 창고 테이프 5종으로 통일(2026-10-04 YZY 16:51) — 중국어(한국어). 라벨(InboundLabel)·핸드폰 入仓은 괄호 한국어를 떼고 쓴다.
// 로켓배송(파생값 '쉽먼트택배')은 표기만 rocket_box 로. 값 '쉽먼트택배' 는 그대로 둔다(商品求购 물류방법과 같은 규칙).
// order = 入库列表 2단 분류(출고형식) 순서
export const OUTBOUND_TYPE_STYLE = {
  milkrun_box: { text: '蓝胶带快递(밀크런택배)', ko: '밀크런택배', color: '#1e63d6', order: 1 },
  normal_box: { text: '红胶带一般快递(일반택배)', ko: '일반택배', color: '#d63333', order: 2 },
  rocket_box: { text: '红胶带快递资料(로켓배송)', ko: '로켓배송', color: '#d63333', order: 3 },
  normal_pallet: { text: '绿胶带货主托盘(3PL화주파렛트)', ko: '3PL화주파렛트', color: '#1f9d55', order: 4 },
  milkrun_pallet: { text: '黑胶带托盘(밀크런파렛트)', ko: '밀크런파렛트', color: '#222222', order: 5 },
  // 박스 단위 값(Labels.shipMethodOverride) — 화주 주소로 보내는 박스(2026-10-04 YZY).
  // YZY 19:33: 「红胶带一般快递及货主地址发货 都是相同的」 ⇒ 박스 단위에서는 normal_box 도 이 값으로 합친다(boxOutboundKey).
  // 상품(요청) 단위 표기 normal_box 「红胶带一般快递」 는 그대로
  customer_address: { text: '红胶带货主地址发货(화주주소발송)', ko: '화주주소발송', color: '#d63333', order: 2 }
};
// 箱子分配 박스별 发货方式 선택지 = 4종(YZY 19:33). 로켓배송(rocket_box)은 여기선 안 고른다 — 계산값이면 「自动」 줄에만 보인다.
// 서버 BOX_SHIP_METHODS 는 옛 6종을 그대로 받는다(이미 저장된 normal_box 등 호환)
export const BOX_SHIP_METHODS = ['milkrun_box', 'customer_address', 'normal_pallet', 'milkrun_pallet'];
const OUTBOUND_TYPE_ALIAS = {
  밀크런택배: 'milkrun_box', 밀크런파렛트: 'milkrun_pallet', 밀크런트럭: 'milkrun_pallet',
  일반택배: 'normal_box', 일반파렛트: 'normal_pallet', 일반트럭: 'normal_pallet',
  쉽먼트택배: 'rocket_box', 로켓배송: 'rocket_box'
};

export function outboundTypeInfo(v) {
  const k = OUTBOUND_TYPE_STYLE[v] ? v : OUTBOUND_TYPE_ALIAS[v];
  return k ? Object.assign({ key: k }, OUTBOUND_TYPE_STYLE[k]) : null;
}
// 구매요청 한 건의 出库形式 — 저장된 필드가 없어 商品求购(logisreqpurchaseV0) 「물류방법」과 같은 규칙으로 요청내역에서 만든다.
// 货主库存出库(ShipmentRequestList)·入仓登记 라벨이 같이 쓴다. 요청내역에 destination·exportType 이 둘 다 없으면 빈칸
export function outboundTypeOfReq(r) {
  const req = (r && r.요청내역) || {};
  if (req.destination === undefined && req.exportType === undefined) return '';
  const 쿠팡 = req.destination === 'coupang';
  const 팔레트 = req.exportType === 'pallet';
  if (r.reqtype === '로켓배송' && 쿠팡) return '쉽먼트택배';
  if (r.reqtype === '제트배송' && 쿠팡) return 팔레트 ? '밀크런트럭' : '밀크런택배';
  return 팔레트 ? '일반트럭' : '일반택배';
}
// 박스 한 개의 出库形式 — 箱子分配에서 박스별로 바꾼 값(Labels.shipMethodOverride)이 먼저, 없으면 요청 기준(outboundTypeOfReq).
// 요청 없이 박스 라벨만 있으면 만들 때 정한 shipmentType. 상품(요청) 단위 표시는 outboundTypeOfReq 를 그대로 쓴다
export function outboundTypeOfBox(box, r) {
  if (box && box.shipMethodOverride) return boxOutboundKey(box.shipMethodOverride);
  if (r) return boxOutboundKey(outboundTypeOfReq(r));
  return boxOutboundKey((box && box.shipmentType) || '');
}
// 박스 단위 표기 — 일반택배(normal_box·'일반택배')는 화주주소발송(customer_address)과 같은 것(YZY 19:33). 나머지는 값 그대로
export function boxOutboundKey(v) {
  const i = outboundTypeInfo(v);
  return i && i.key === 'normal_box' ? 'customer_address' : v;
}
export function outboundTypeText(v) {
  const i = outboundTypeInfo(v);
  return i ? i.text : (v || '');
}
// 칩·배지에 바로 :style 로 — 선택 안 된 버튼이면 outline=true(테두리·글자만 그 색)
export function outboundTypeStyle(v, outline) {
  const i = outboundTypeInfo(v);
  if (!i) return {};
  return outline
    ? { borderColor: i.color, color: i.color, background: '#fff' }
    : { borderColor: i.color, color: '#fff', background: i.color };
}
